// extracted by mini-css-extract-plugin
export default {"customInputContainer":"CiNkBudD7Ayl510dxuy8"};